/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  $('#nav_drawer a').on('click', function() {
    $('.header__mobile__hamburger').trigger('click')
   });
  $(window).on('load', function() {
    $('.shopify-section[id$="16289946329bd6e447"]').on('click', function() {
      var videoElem = document.querySelector('video[id$="16289946329bd6e447-video-background"]');
      if(!$(this).hasClass('colored')) {
        videoElem.currentTime = 0;
      	$(this).addClass('colored');
      }
      if(!$(this).hasClass('play')) {
        videoElem.play();
        videoElem.muted = false;
        videoElem.volume = 0.75;
      	$(this).addClass('play');
      } else {
        videoElem.pause();
      	$(this).removeClass('play');
      }
     });
    
      //「都道府県」一覧置換
      let prefectures = [["Hokkaido","北海道"],["Aomori","青森県"],["Iwate","岩手県"],["Miyagi","宮城県"],["Akita","秋田県"],["Yamagata","山形県"],["Fukushima","福島県"],["Ibaraki","茨城県"],["Tochigi","栃木県"],["Gunma","群馬県"],["Saitama","埼玉県"],["Chiba","千葉県"],["Tokyo","東京都"],["Kanagawa","神奈川県"],["Niigata","新潟県"],["Toyama","富山県"],["Ishikawa","石川県"],["Fukui","福井県"],["Yamanashi","山梨県"],["Nagano","長野県"],["Gifu","岐阜県"],["Shizuoka","静岡県"],["Aichi","愛知県"],["Mie","三重県"],["Shiga","滋賀県"],["Kyoto","京都府"],["Osaka","大阪府"],["Hyogo","兵庫県"],["Nara","奈良県"],["Wakayama","和歌山県"],["Tottori","鳥取県"],["Shimane","島根県"],["Okayama","岡山県"],["Hiroshima","広島県"],["Yamaguchi","山口県"],["Tokushima","徳島県"],["Kagawa","香川県"],["Ehime","愛媛県"],["Kochi","高知県"],["Fukuoka","福岡県"],["Saga","佐賀県"],["Nagasaki","長崎県"],["Kumamoto","熊本県"],["Oita","大分県"],["Miyazaki","宮崎県"],["Kagoshima","鹿児島県"],["Okinawa","沖縄県"]];
      $("select[name='address[country]'] option[value='Japan']").attr("data-provinces",'[["Hokkaido","北海道"],["Aomori","青森県"],["Iwate","岩手県"],["Miyagi","宮城県"],["Akita","秋田県"],["Yamagata","山形県"],["Fukushima","福島県"],["Ibaraki","茨城県"],["Tochigi","栃木県"],["Gunma","群馬県"],["Saitama","埼玉県"],["Chiba","千葉県"],["Tokyo","東京都"],["Kanagawa","神奈川県"],["Niigata","新潟県"],["Toyama","富山県"],["Ishikawa","石川県"],["Fukui","福井県"],["Yamanashi","山梨県"],["Nagano","長野県"],["Gifu","岐阜県"],["Shizuoka","静岡県"],["Aichi","愛知県"],["Mie","三重県"],["Shiga","滋賀県"],["Kyoto","京都府"],["Osaka","大阪府"],["Hyogo","兵庫県"],["Nara","奈良県"],["Wakayama","和歌山県"],["Tottori","鳥取県"],["Shimane","島根県"],["Okayama","岡山県"],["Hiroshima","広島県"],["Yamaguchi","山口県"],["Tokushima","徳島県"],["Kagawa","香川県"],["Ehime","愛媛県"],["Kochi","高知県"],["Fukuoka","福岡県"],["Saga","佐賀県"],["Nagasaki","長崎県"],["Kumamoto","熊本県"],["Oita","大分県"],["Miyazaki","宮崎県"],["Kagoshima","鹿児島県"],["Okinawa","沖縄県"]]');
    
      //「国」プルダウン分ループ
      $("select[name='address[country]']").each(function(){
        
        //「日本」選択時
        if($(this).val()=="Japan"){
          
          // DOM/現在値取得
          formDom = $(this).closest("form");
          selectProvince = formDom.find("select[name='address[province]']").val();
          
          //「都道府県」プルダウン選択肢置換
          formDom.find("select[name='address[province]']").empty();
          $.each(prefectures, function(index,prefecture) {
            formDom.find("select[name='address[province]']").append('<option value="' + prefecture[0] + '">' + prefecture[1] + '</option>');
          });
          if(formDom.prop("id")!="address_form_new") formDom.find("select[name='address[province]']").val(selectProvince);
          
        }
      });

    });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
  
  
})();